import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { SharedRespLinksBlock } from '../../shared/SharedRespLinksBlock/SharedRespLinksBlock';
import { moreWaysToBrowseHeader } from '../../shared/sharedMessages';

const SharedRespMoreWaysToBrowseComponent = ({ internalBuyLinks }) => {
    if (internalBuyLinks && internalBuyLinks.length) {
        return (
            <SharedRespLinksBlock
                title={moreWaysToBrowseHeader}
                links={internalBuyLinks}
                dataTn={'sb-resp-more-ways-to-browse'}
            />
        );
    }

    return null;
};

SharedRespMoreWaysToBrowseComponent.propTypes = {
    internalBuyLinks: PropTypes.arrayOf(
        PropTypes.shape({
            anchorText: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        })
    ),
};

export const SharedRespMoreWaysToBrowse = createFragmentContainer(
    SharedRespMoreWaysToBrowseComponent,
    {
        internalBuyLinks: graphql`
            fragment SharedRespMoreWaysToBrowse_internalBuyLinks on InternalBuyLinkType
                @relay(plural: true) {
                anchorText
                url
            }
        `,
    }
);
